// assets/countdown.js

if (!customElements.get('custom-countdown')) {
  class CustomCountdown extends HTMLElement {
    constructor() {
      super();
      // Shopify helper: defer init until in view
      window.initScriptOnDemand(this, this.init.bind(this));

      // Eager init if requested
      if (this.dataset.loading === 'eager') {
        this.init();
      }
    }

    init() {
      // Read flags & messages
      this.dailyReset  = this.dataset.dailyReset === 'true';      // true when only end_time is set
      this.endAction   = this.dataset.endAction  || 'zero';
      this.endMessage  = this.dataset.endMessage || '';

      // Locate display spans
      this.daysElem    = this.querySelector('.js-days');
      this.hoursElem   = this.querySelector('.js-hours');
      this.minutesElem = this.querySelector('.js-minutes');
      this.secondsElem = this.querySelector('.js-seconds');

      // Time constants
      this.SEC  = 1000;
      this.MIN  = this.SEC * 60;
      this.HOUR = this.MIN * 60;
      this.DAY  = this.HOUR * 24;

      // Parse initial end-timestamp
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!this.endDate) return;  // invalid date

      // Initial render + start ticking
      this.nextTick();
      this.intervalTimer = setInterval(this.nextTick.bind(this), this.SEC);
    }

    nextTick() {
      const now       = Date.now();
      let   remaining = this.endDate - now;

      // --- Daily‐reset mode: keep rolling over every 24h ---
      if (remaining <= 0 && this.dailyReset) {
        this.endDate += this.DAY;
        remaining = this.endDate - now;
      }

      // --- Fixed end‐date mode: stop when passed ---
      if (remaining <= 0 && !this.dailyReset) {
        clearInterval(this.intervalTimer);

        switch (this.endAction) {
          case 'hide':
            this.remove();
            break;

          case 'message':
            this.innerHTML = this.endMessage;
            break;

          case 'zero':
          default:
            // Force all to "00"
            ['daysElem','hoursElem','minutesElem','secondsElem'].forEach(key => {
              if (this[key]) this[key].textContent = '00';
            });
            this.setAttribute(
              'data-digits',
              2 +
                (this.daysElem    ? 1 : 0) +
                (this.hoursElem   ? 1 : 0) +
                (this.minutesElem ? 1 : 0) +
                (this.secondsElem ? 1 : 0)
            );
        }

        return;
      }

      // --- Compute time components ---
      const daysTotal  = Math.floor(remaining / this.DAY);
      const hoursTotal = Math.floor(remaining / this.HOUR);
      const minsTotal  = Math.floor(remaining / this.MIN);
      const secsTotal  = Math.floor(remaining / this.SEC);

      // Remove days/hours blocks when they hit zero (optional)
      if (daysTotal === 0 && this.daysElem) {
        this.daysElem.closest('.countdown__block').remove();
        this.daysElem = null;

        if (this.hoursElem && (hoursTotal % 24) === 0) {
          this.hoursElem.closest('.countdown__block').remove();
          this.hoursElem = null;
        }
      }

      // Rollover
      const remDays  = daysTotal;
      const remHours = hoursTotal % 24;
      const remMins  = minsTotal  % 60;
      const remSecs  = secsTotal  % 60;

      // Update display
      let digits = 2;
      if (this.daysElem) {
        this.daysElem.textContent = remDays  < 10 ? `0${remDays}` : `${remDays}`;
        digits++;
      }
      if (this.hoursElem) {
        this.hoursElem.textContent = remHours < 10 ? `0${remHours}` : `${remHours}`;
        digits++;
      }
      if (this.minutesElem) {
        this.minutesElem.textContent = remMins  < 10 ? `0${remMins}` : `${remMins}`;
        digits++;
      }
      if (this.secondsElem) {
        this.secondsElem.textContent = remSecs  < 10 ? `0${remSecs}` : `${remSecs}`;
        digits++;
      }

      this.setAttribute('data-digits', digits);
    }
  }

  customElements.define('custom-countdown', CustomCountdown);
}
